module.exports = __webpack_public_path__ + "img/icon-salir.24e542c1.svg";